/** The Salidas screen's memory of who went where: how many of the last runs the campaign keeps for the history list. */
export const OUTINGS = { recent: 300 };
